module.exports = __webpack_public_path__ + "images/free-data-science-month.jpg";